import { action, computed, makeObservable } from 'mobx';
import { T } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { AppStore } from '../../store';
import { AutoCompleteMenu, type SelectAutoCompleteOption } from '../autocomplete.menu/autocomplete.menu';
import { IMithrilStateComponent } from '../mithril.component';
import { Input } from './input';
import { InputState } from './input.state';

export class TagNameInputState extends IMithrilStateComponent {
	state: InputState<string> = new InputState<string>(T.TAG_NAME);

	menu: AutoCompleteMenu;

	get value() {
		return this.state.value;
	}

	constructor() {
		super();
		makeObservable(this);

		this.menu = new AutoCompleteMenu({
			inputState: this.state,
			options: () => this.autoCompleteOptions,
			onselect: (opt) => this.accept(opt.id),
			showNew: true,
		});
	}

	get nodes(): MithrilVNode {
		return m('div', { className: 'c-TagInput' }, [Input.view(this.state), this.menu.view()]);
	}

	@action.bound accept(value?: string) {
		if (value) {
			this.state.setValue(value);
		}
	}

	clearValue() {
		this.state.setValue(null);
	}

	@computed get autoCompleteOptions(): SelectAutoCompleteOption[] {
		const tags: SelectAutoCompleteOption[] = [];
		for (const tag of AppStore.Tag.all) {
			const tagSummary = AppStore.TagSummary.get(tag.objectId);
			if (tagSummary == null || tagSummary.revisions.length === 0) {
				continue;
			}

			tags.push({ id: tag.name, value: tag.name });
		}
		return tags;
	}
}
